import { _decorator, Enum, ParticleSystem, CCInteger } from 'cc';
import { DEV } from 'cc/env';
import BaseAction from './BaseAction';

const { ccclass, property } = _decorator;

// 粒子行為
export enum ParticleActionType {
    Active,
    Inactive,
    OnlyChangeProperty,
}

@ccclass('ParticleAction')
export default class ParticleAction extends BaseAction {
    @property({ type: ParticleSystem, displayName: DEV && '粒子元件', tooltip: DEV && '粒子對象' })
    public readonly particle: ParticleSystem = null;
    @property({
        type: Enum(ParticleActionType),
        displayName: DEV && '操作類型',
        tooltip: DEV && '要進行什麼行為\r\nActive: 顯示\r\nInActive: 關閉\r\nOnlyChangeProperty: 只調整參數',
    })
    public readonly type: ParticleActionType = ParticleActionType.Active;
    @property({ displayName: DEV && '調整Loop狀態', tooltip: DEV && '啟用後, 可以重新指定是否要Loop' })
    public readonly changeLoopStatus: boolean = false;
    @property({
        displayName: DEV && 'Loop狀態',
        tooltip: DEV && '指定是否要啟用Loop',
        visible(this: ParticleAction) {
            return this.changeLoopStatus;
        },
    })
    public readonly isLoop: boolean = false;
    @property({ displayName: DEV && '調整亂數種子', tooltip: DEV && '啟用後, 會從列表中隨機挑一個亂數種子指定' })
    public readonly updateRandomSeed: boolean = false;
    @property({
        type: [CCInteger],
        displayName: DEV && '亂數種子列表',
        tooltip: DEV && '隨機指定列表中一個亂數種子',
        visible(this: ParticleAction) {
            return this.updateRandomSeed;
        },
    })
    public readonly randomSeedList: number[] = [];
    @property({
        displayName: DEV && '延遲播放',
        tooltip: DEV && '啟用後會 "晚一幀" 執行play',
        visible(this: ParticleAction) {
            return this.type === ParticleActionType.Active;
        },
    })
    public readonly delayStart: boolean = false;
}
